window.moment = require('moment');

import { createApp } from 'vue/dist/vue.esm-bundler.js';
import ElementPlus from 'element-plus'
import hu from 'element-plus/dist/locale/hu.mjs';
import 'element-plus/theme-chalk/index.css';

window.marked = require('marked');

import Email from './components/Email.vue';
import Quotes from './components/Quotes.vue';
import SearchView from './pages/SearchView.vue';
import router from './router';
import VueEloquent from 'vue-eloquent';
import Vuex from 'vuex';
import WorldMap from './components/WorldMap.vue';

require('./pages/project.js');
require('./google-maps.js');

function position(element, image, event) {
    if (element.getBoundingClientRect().bottom > 0 && element.getBoundingClientRect().top < window.innerHeight) {
        var top = element.getBoundingClientRect().top - element.offsetTop;
        var height = window.innerHeight;
        var percent = Math.abs(top) / height;
        image.style.top = height / 2 * percent + 'px';
    }
}

window.initMap = function () {

    var mapEl = document.getElementById('map');
    var geocoder = new google.maps.Geocoder();
    var address = mapEl.attributes['data-address'].value;

    geocoder.geocode({
        'address': address
    }, function (results, status) {

        if (status == google.maps.GeocoderStatus.OK) {

            var latlng = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
            };

            var map = new google.maps.Map(mapEl, {
                center: latlng,
                scrollwheel: false,
                zoom: 8
            });

            var image = '/img/marker.svg';

            var marker = new google.maps.Marker({
                position: latlng,
                map: map,
                title: address,
                icon: image
            });

            map.setOptions({ styles: window.googleMaps.styles });

        }

    });

}

var video = document.getElementById("hero-video");
if (video) video.addEventListener("canplay", function () {
    video.play();
});


const cehApp = createApp({
    components: {
        'email-tag': Email,
        WorldMap,
        Quotes,
        'search-view': SearchView
    },
    mounted() {
        var parallax = window.document.querySelectorAll('.hero.parallax');
        parallax.forEach(element => {
            var image = element.querySelector('.image');
            window.addEventListener('scroll', position.bind(this, element, image));
        });

        window.addEventListener('scroll', this.onScroll);
        this.onScroll();

    },
    methods: {
        onScroll(event) {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            this.scrollDirection = st > this.lastScroll ? 'down' : 'up';
            this.lastScroll = st <= 0 ? 0 : st;
            var nav = document.querySelector('#header');
            nav.classList.toggle('up', this.scrollDirection === 'up');
            nav.classList.toggle('down', this.scrollDirection === 'down');
            nav.classList.toggle('absolute', st < 150);
        },
        toggleSubmenu(ref, event) {
            this.$refs[ref].classList.toggle('show');
        },
        toggleNav() {
            document.body.classList.toggle('freeze', this.$refs.header.classList.value.indexOf('show-nav') === -1);
            this.$refs.header.classList.toggle('show-nav');
        }
    },
    data() {
        return {
            scrollDirection: '',
            lastScroll: 0
        }
    }
});
cehApp.use(router);
cehApp.use(ElementPlus, {
    locale: hu,
});
cehApp.use(VueEloquent);
router.isReady().then(() => {
    cehApp.mount('#ceh-app')
});
